module.exports = __webpack_public_path__ + "static/img/bcg.68ac2c5a.webp";